import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/config";

export const fmtDate = (d) =>
  new Date(d + "T12:00:00").toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" });

export const toKey = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function useAppointments(headers) {
  const [items, setItems] = useState(null);
  const [services, setServices] = useState([]);
  const [reviewLink, setReviewLink] = useState("");

  const load = () => {
    axios
      .get(`${API}/admin/appointments`, { headers })
      .then((res) => setItems(res.data))
      .catch(() => toast.error("No se pudieron cargar las citas"));
    axios.get(`${API}/services`).then((r) => setServices(r.data)).catch(() => {});
    axios.get(`${API}/reviews`).then((r) => setReviewLink(r.data.link || "")).catch(() => {});
  };

  const replace = (a) => setItems((prev) => prev.map((x) => (x.id === a.id ? { ...x, ...a } : x)));

  const update = async (id, payload) => {
    try {
      const res = await axios.put(`${API}/admin/appointments/${id}`, payload, { headers });
      replace(res.data);
      const s = payload.status;
      if (s === "confirmada") {
        if (res.data.confirmation_email === "enviado") toast.success("Cita confirmada · email enviado a la clienta");
        else if (res.data.confirmation_email === "sin_correo") toast.warning("Cita confirmada · esta cita no tiene correo");
        else toast.error("Cita confirmada, pero no se pudo enviar el email");
      } else if (s === "completada") toast.success(`Registrado: ${res.data.price} € · ya cuenta en Mis clientas`);
      else if (s === "no_show") toast.warning("Marcada como falta · se suma a su contador");
      else toast.success("Cita actualizada");
      return res.data;
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo actualizar la cita");
    }
  };

  const remove = async (id) => {
    if (!window.confirm("¿Eliminar esta cita?")) return;
    try {
      await axios.delete(`${API}/admin/appointments/${id}`, { headers });
      setItems((prev) => prev.filter((a) => a.id !== id));
      toast.success("Cita eliminada");
    } catch {
      toast.error("No se pudo eliminar");
    }
  };

  const resend = async (id) => {
    try {
      const res = await axios.post(`${API}/admin/appointments/${id}/resend`, {}, { headers });
      replace(res.data);
      toast.success("Correo reenviado a la clienta");
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo reenviar el correo");
    }
  };

  const add = (a) => setItems((prev) => [...(prev || []), a].sort((x, y) => (x.date + x.time).localeCompare(y.date + y.time)));

  return { items, services, load, update, remove, add, replace, reviewLink, resend };
}
